import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";

const useRemoveCourierPrivilege = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const removeCourierPrivilege = async (userId) => {
		const instance = await InitApi({ accessToken });

		const res = await instance.patch(
			`users/remove-courier-privilege/${userId}`
		);
		await queryClient.invalidateQueries(["users"]);
		return res.data;
	};

	return useMutation(removeCourierPrivilege, {
		onSuccess: async () => {
			toast.success("Courier privilege removed successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useRemoveCourierPrivilege;
